import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import histogram from 'highcharts/modules/histogram-bellcurve';

histogram(Hightcharts);


const ChartHistogram = ({chartData, title}) => {
	if (chartData == undefined || chartData.length == 0) {
		return
	}

	const optionsBar = {
		chart: {
			type: 'column',
		  },
		  title: {
			text: title,
			style : {
				color : '#000',
				fontSize : '14px',
				fontWeight : 'bold'
			}
		  },
		  yAxis: {
			title: {
			  text: '인구수(명)',
			},
		  },
		  series: [
			{
			  name: '거리차(km)',
			  type: 'histogram',
			  data: chartData,
			  binsNumber: 1,
			  tooltip: {
				pointFormat: "거리차: <b>{point.x:.0f} km</b><br/>인구수: <b>{point.y:,.0f}</b>"
			  }
			},
		  ],
	  };

	return (
		<>
			<HighchartsReact highcharts={Hightcharts} options={optionsBar} containerProps={{ style: {width:'100%' , height: "90%" }}} />
		</>
	);
};

export default ChartHistogram;